const STORAGE_KEY = "bordona-scale-path-progress";

export type ScalePathProgress = {
  completedMissionIds: string[];
};

export function defaultScalePathProgress(): ScalePathProgress {
  return { completedMissionIds: [] };
}

export function loadScalePathProgress(): ScalePathProgress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultScalePathProgress();
    const p = JSON.parse(raw) as Partial<ScalePathProgress>;
    return {
      completedMissionIds: Array.isArray(p.completedMissionIds) ? p.completedMissionIds : [],
    };
  } catch {
    return defaultScalePathProgress();
  }
}

export function saveScalePathProgress(progress: ScalePathProgress): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
}

export function markScalePathMissionComplete(
  progress: ScalePathProgress,
  missionId: string
): ScalePathProgress {
  if (progress.completedMissionIds.includes(missionId)) return progress;
  return {
    completedMissionIds: [...progress.completedMissionIds, missionId],
  };
}
